/* eslint-disable no-unused-vars */
import Header from "../../components/Header";
import { Country } from "../../models/Country";
import { PAGE_CHECKOUT } from "./constant";
import StripePayment from "./components/PaymentInfo/components/StripePayment";
import BankTransferModal from "./components/PaymentInfo/components/BankTransferModal";
import SectionLoading from "../../components/SectionLoading";
import { Order } from "../../models/Order";
import CreateLink from "./components/CreateLink";
import ProductSummary from "./components/ProductSummary";
import BillingSummary from "./components/BillingSummary";
import PaymentInfo from "./components/PaymentInfo";
import CustomerInfo from "./components/CustomerInfo";
import ProductSummaryPopup from "./components/ProductSummaryPopup";
import DToast from "../../components/DToast";
import { getParamUrl } from "../../utils/url";
import MenuDropDown from "../../components/MenuDropDown";
import { isMobileByWidth } from "../../utils/utils";
import StripeGoogleApple from "./components/PaymentInfo/components/StripeGoogleApple";

export class StateCheckOut {
  static page = PAGE_CHECKOUT.SHOPPING_CART;
  /**@type {Order} */
  static order = {};
  static orderCode;
  static paymentMethod;
  static paymentProvider;
  static atmSelected;
  static paymentList = [];
  static isFirst = true;
  static isFirstSetUpFireBase = true;
  static isView = false;
  static isEdited = true;
  static chargeSecret;
  static paymentCode;
  static directOrderCode;
  static isUncheckProduct;
  static noSelectedProduct;
  static productIds = [];
  static _CountryData = [];
  static get CountryData() {
    if (!StateCheckOut._CountryData.length) {
      StateCheckOut._CountryData = Country.getCountryList();
    }
    return StateCheckOut._CountryData;
  }
  static set CountryData(value) {
    StateCheckOut._CountryData = value;
  }
  static settings = "";
  static isForceUpdate = true;
  static priceTags = [];
  /** @type {Header} */
  static header;
  /**@type {BankTransferModal} */
  static bankTransferModal;
  /**@type {StripePayment} */
  static paymentStripeModal;
  /**@type {StripeGoogleApple} */
  static paymentStripeGoogle;
  /**@type {StripeGoogleApple} */
  static paymentStripeApple
  /**@type {SectionLoading} */
  static allLoading = new SectionLoading({ parent: "body", isFullPage: true });
  /**@type {ProductSummary} */ static _shoppingCart;
  static get shoppingCart() {
    if (!StateCheckOut._shoppingCart) {
      StateCheckOut._shoppingCart = new ProductSummary({ parent: ".step-shopping-cart .infomation-body .shopping-cart", defaultLoading: true })
    }
    return StateCheckOut._shoppingCart;
  }
  static set shoppingCart(value) {
    StateCheckOut._shoppingCart = value;
  }
  /**@type {ProductSummary} */ static _orderDetail;
  static get orderDetail() {
    if (!StateCheckOut._orderDetail) {
      StateCheckOut._orderDetail = new ProductSummary({ parent: "#order_details .order-details-data", isView: true, defaultLoading: true })
    }
    return StateCheckOut._orderDetail;
  }
  static set orderDetail(value) {
    StateCheckOut._orderDetail = value;
  }
  /**@type {CustomerInfo} */ static _customerInfo;
  static get customerInfo() {
    if (!StateCheckOut._customerInfo) {
      StateCheckOut._customerInfo = new CustomerInfo({
        parent: "#address_information",
        countryList: StateCheckOut.CountryData,
        ...StateCheckOut.customerInfoSetting
      });
    }
    return StateCheckOut._customerInfo;
  }
  static set customerInfo(value) {
    StateCheckOut._customerInfo = value;
  }
  static customerInfoSetting = {};

  /**@type {BillingSummary} */ static _billingSummary;
  static get billingSummary() {
    if (!StateCheckOut._billingSummary) {
      StateCheckOut._billingSummary = new BillingSummary({
        parent: "#payment_details .infomation-body",
        title: "checkout_paymentDetails",
        promotionCode: getParamUrl("pc"),
        referralCode: getParamUrl("rc"),
        hasItemCart: false,
        isCheckout: true,
        defaultLoading: true
      });
    }
    return StateCheckOut._billingSummary;
  }
  /**@type {PaymentInfo} */ static _paymentInfo;
  static get paymentInfo() {
    if (!StateCheckOut._paymentInfo) {
      StateCheckOut._paymentInfo = new PaymentInfo({
        parent: ".step-order-details .infomation-body #payment_options",
        ...StateCheckOut.paymentInfoSetting
      });
    }
    return StateCheckOut._paymentInfo;
  }
  static set paymentInfo(value) {
    StateCheckOut._paymentInfo = value;
  }
  static paymentInfoSetting = {};

  /**@type {CreateLink} */ static _createLink;
  static get createLink() {
    if (!StateCheckOut._createLink) {
      StateCheckOut._createLink = new CreateLink({ id: "create_direct_link", parent: ".direct-link", isModal: isMobileByWidth(), })
    }
    return StateCheckOut._createLink;
  }
  static set createLink(value) {
    StateCheckOut._createLink = value;
  }
  /**@type {ProductSummaryPopup} */ static _orderDetailDialog;
  static get orderDetailDialog() {
    if (!StateCheckOut._orderDetailDialog) {
      StateCheckOut._orderDetailDialog = new ProductSummaryPopup({
        parent: ".main-page",
        isBack: true,
      })
    }
    return StateCheckOut._orderDetailDialog;
  }
  static set orderDetailDialog(value) {
    StateCheckOut._orderDetailDialog = value;
  }
  /**@type {DToast} */ static _toast;
  static get toast() {
    if (!StateCheckOut._toast) {
      StateCheckOut._toast = new DToast({ parent: ".main-page", fixedPosition: true })
    }
    return StateCheckOut._toast;
  }
  static set toast(value) {
    StateCheckOut._toast = value;
  }

  /** @type {MenuDropDown} */ static menuNavigation;
}